import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Menubar } from 'primereact/menubar'
import SmsDashboard from './SmsDashboard'
import CompanyMobile from './CompanyMobile'
import * as smsActions from '../../_actions/sms.actions'
import SMS from './SMS'
import ContactsMng from './ContactsMng'
import ColorCustomization from './theme/ColorCustomization'
import TemplateForm from './TemplateForm'
import { Button } from 'primereact/button'
// import 'primereact/resources/themes/nova-light/theme.css'
// import 'primereact/resources/primereact.min.css'
// import 'primeicons/primeicons.css'

class Settings extends Component {
    state = {
        page: '',
    }

    componentDidMount = () => {
        this.setState({ page: 'dashboard' })
        this.props.actions.smsActions.statisticsSms()
    }

    render() {
        const items = [
            // {
            {
                label: 'dashboard',
                icon: 'pi pi-fw pi-chart-line',
                command: () => this.setState({ page: 'dashboard' }),
            },
            {
                label: 'Company Mobile',
                icon: 'pi pi-fw pi-mobile',
                command: () => this.setState({ page: 'numbers' }),
            },

            // label: 'SMS',
            // icon: 'pi pi-fw pi-comment',
            // items: [
            //     {
            //         label: 'dashboard',
            //         icon: 'pi pi-fw pi-chart-line',
            //         command: () => this.setState({ page: 'dashboard' }),
            //     },
            //     {
            //         label: 'Company Mobile',
            //         icon: 'pi pi-fw pi-mobile',
            //         command: () => this.setState({ page: 'numbers' }),
            //     },
            // {
            //     label: 'Quick SMS',
            //     icon: 'pi pi-fw pi-comments',
            //     command: () => this.setState({ page: 'sms' }),
            // },
            // ],
            // },
            // {
            //     label: 'Contacts',
            //     icon: 'pi pi-fw pi-users',
            //     items: [
            //         {
            //             label: 'Manage Contacts',
            //             icon: 'pi pi-fw pi-user-edit',
            //             command: () => this.setState({ page: 'contactsMng' }),
            //         },
            //     ],
            // },
            // {
            //     label: 'Appearance',
            //     icon: 'pi pi-fw pi-pencil',
            //     items: [
            //         {
            //             label: 'Color Cutomization',
            //             icon: 'pi pi-fw pi-palette',
            //             command: () => this.setState({ page: 'ColorCustomization' }),
            //         },
            //     ],
            // },
        ]

        const { page } = this.state

        return (
            <div className="">
                <div className="row">
                    <div className=" col-sm-12 col-md-12">
                        <Menubar model={items} />
                    </div>
                </div>

                {page === 'dashboard' && <SmsDashboard />}
                {page === 'numbers' && <CompanyMobile />}
                {page === 'sms' && <SMS />}
                {/* {page === 'templates' && <TemplateForm />} */}
                {/* {page === 'smshistory' && <History />} */}
                {page === 'contactsMng' && <ContactsMng />}
                {page === 'ColorCustomization' && <ColorCustomization />}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        sms: state.sms,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            smsActions: bindActionCreators(smsActions, dispatch),
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Settings)
